import { MESSAGE_TYPES } from 'components';
import { keyValueMirror } from 'store/store-functions';
import { addMessage } from 'store/actions/app';

const {
    VITE_API_DEV_HOST,
    VITE_AUTHENTICATION_HOST,
    VITE_CLIENT_ID: clientId,
} = process.env;

const baseUrl = VITE_API_DEV_HOST;

export const actions = [
    'SET_OAUTH_LOADING',
    'GET_OAUTH_CLIENTS_ADMIN',
];
const keyActions = keyValueMirror(...actions);

export const setOauthLoading = value => ({
    type: keyActions.SET_OAUTH_LOADING,
    payload: value,
});

export const getOauthClientsAdmin = token => async dispatch => {
    const params = window.location.search;

    const url = `${baseUrl}/admin/oauth/clients${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setOauthLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve Clients.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: keyActions.GET_OAUTH_CLIENTS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve Clients.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setOauthLoading(false));
    }
};
